export default angular.module('app.filterNumbers', [])
  .filter('filterNumbers', function($filter) {
    return function(objects, field, value) {
      let filter, operation, ref;
      if (!value)
        return objects;

      value = value.trim().replace(/^</, '< ').replace(/^=/, '= ').replace(/^>/, '> ');
      ref = value.trim().split(/\s+/), operation = ref[0], value = ref[1];
      value = parseInt(value);

      switch (operation) {
        case '<':
          return objects.filter(function(o) {
            return o[field] < value;
          });
        case '=':
          return objects.filter(function(o) {
            return o[field] === value;
          });
        case '>':
          return objects.filter(function(o) {
            return o[field] > value;
          });
        default:
          return $filter('filter')(objects, {[field]: value});
      }
    };
  })
  .filter( 'shortNumber', function() {
    return function( number ) {
      if ( typeof number === 'number' ) {
        let abs = Math.abs( number );
        if ( abs >= Math.pow( 10, 12 ) ) {
          // trillion
          number = ( number / Math.pow( 10, 12 ) ).toFixed( 1 ) + "T";
        } else if ( abs < Math.pow( 10, 12 ) && abs >= Math.pow( 10, 9 ) ) {
          // billion
          number = ( number / Math.pow( 10, 9 ) ).toFixed( 1 ) + "B";
        } else if ( abs < Math.pow( 10, 9 ) && abs >= Math.pow( 10, 6 ) ) {
          // million
          number = ( number / Math.pow( 10, 6 ) ).toFixed( 1 ) + "M";
        } else if ( abs < Math.pow( 10, 6 ) && abs >= Math.pow( 10, 3 ) ) {
          // thousand
          number = ( number / Math.pow( 10, 3 ) ).toFixed( 1 ) + "K";
        }

        return number;
      }
    };
  });



/** WEBPACK FOOTER **
 ** ./src/filters/filterNumbers.js
 **/